import { RootComponent } from './root.component';

export default angular
  .module('mcp.admin.root', ['mcb.components.toast'])
  .component('mcpAdminRoot', RootComponent.Factory());
